
class HXFormFieldSort extends HXFormField {
    constructor(inputName,formName) {
        super(inputName,formName);
    }

    /**
     * Liefert den Text der gewaehlten Option
     * @returns {string}
     */
    getSelectedText() {
        return this.inputObj.options[this.inputObj.selectedIndex].text;
    }

    /**
     * Liefert den Value der gewaehlten Option - identisch zu .getValue()
     * @returns {string}
     */
    getSelectedValue() {
        return this.getValue();
    }

    /**
     * @param {boolean} optional
     */
    setOptional(optional) {
        super.setOptional(optional,'select');
    }

    /**
     * @returns {boolean}
     */
    validateInput(alertResult=true) {
        super._validateFieldInit();
        //keine Validierung notwendig (OptionEmpty gibts nicht daher auch keine Pflichtfeldpruefung)
        return this.validationPassed;
    }

    displayInit() {

    }
}